import script from "./AuthPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthPanel.vue?vue&type=script&setup=true&lang=ts"

import "./AuthPanel.vue?vue&type=style&index=0&id=054f5776&lang=css"

const __exports__ = script;

export default __exports__